import script from "./Salon2.vue?vue&type=script&setup=true&lang=js"
export * from "./Salon2.vue?vue&type=script&setup=true&lang=js"

import "./Salon2.vue?vue&type=style&index=0&id=1363e033&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1363e033"]])

export default __exports__